export const servicesData = [
  {
    id: 1,
    title: "WASH Video Production",
    category: "wash",
    description:
      "Specialized video production for water, sanitation, and hygiene awareness campaigns.",
    features: [
      "Scriptwriting and storyboarding",
      "Field production and filming",
      "Expert interviews",
      "Community engagement documentation",
    ],
    icon: "💧",
    price: "Custom Quote",
  },
];
